var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWebflowIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.2857 6.2854L16.1473 18.2854H10.3815L12.9505 13.3121H12.8352C10.7159 16.0633 7.55375 17.8744 3.04822 18.2854V13.3809C3.04822 13.3809 5.93051 13.2107 7.62493 11.4292H3.04822V6.2855H8.19196V10.5161L8.3074 10.5157L10.4093 6.2855H14.2994V10.4893L14.4149 10.4891L16.5956 6.2854H22.2857Z",
    fill: "#146EF5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWebflowIcon);
export default __webpack_public_path__ + "static/media/webflow_icon.5bb1906143ba2093c1d597b54cc3f051.svg";
export { ForwardRef as ReactComponent };